import React from "react";
import DropZone from "react-dropzone";
import ImagePreview from "../../helpers/DropzoneField/ImagePreview";
import Placeholder from '../../helpers/DropzoneField/Placeholder';
import '../../helpers/DropzoneField/dropzone.css';

class DropZoneField extends React.Component {
  
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this)
  
  }
  
  onChange = (e) => {
    //console.log(e);
  };
  
  render() {
    return (
      <div className="preview-container">
        <DropZone
          accept={this.props.accept}
          className="upload-container"
          onDrop={file => this.props.handleOnDrop(file, this.onChange)}
          multiple={this.props.multiple}
        >
          {({getRootProps, getInputProps}) => {
            if (this.props.formFile && this.props.formFile.length > 0) {
              return (
                <div>
                  <ImagePreview imageFile={this.props.formFile}/>
                  <Placeholder
                    error={this.props.error}
                    touched={this.props.touched}
                    label={this.props.label}
                    getInputProps={getInputProps}
                    getRootProps={getRootProps}
                  />
                </div>
              );
            } else {
              return (
                <Placeholder
                  error={this.props.error}
                  touched={this.props.touched}
                  getInputProps={getInputProps}
                  getRootProps={getRootProps}
                  label={this.props.label}
                />
              );
            }
          }
          }
        
        </DropZone>
        {/*<ShowError error={error} touched={touched}/>*/}
      </div>
    );
  }
  
}


export default DropZoneField;
